import { dateFormatMap, dateTypeMap } from '@/pages/opinion/constants';
import {
  dealwithLanguage,
  formatTime,
  sentimentNumber,
  tryTransNumber,
  biggerOrTo,
} from '../../render-helper';

// const freePlayedRefundedMap: any = {
//   0: 'No',
//   1: 'Yes',
// };

// function dealwithFreeRefundedValue(
//   item: { [x: string]: number },
//   key: string | number,
// ) {
//   const value = item[key] || 0;
//   return freePlayedRefundedMap[value];
// }

export default function steamMetricsColumns(params: any) {
  let { group_bys = [], metrics = [], date_type } = params || {};
  let dateType = dateTypeMap[date_type];
  let groupBysColumns: any = {
    time: {
      renderHelper: [formatTime(dateFormatMap[dateType])],
      header: 'Date',
      render: 'time',
    },
    language: {
      renderHelper: [dealwithLanguage],
      header: 'Language',
      render: 'language',
    },
    sentiment: {
      header: 'Sentiment',
      render: 'sentiment',
      renderHelper: [sentimentNumber],
      numFmt: ['0.00'],
    },
  };

  // function formatTimeInfo(item: any, key: string) {
  //   const value = item[key];

  //   return Number(value).toFixed(2);
  // }

  const metricsColumns: any = {
    mentions: {
      text: 'Mentions',
      value: 'mentions',
      renderHelper: [biggerOrTo(0, '-'), tryTransNumber],
      numFmt: '#,##',
    },

    recommend: {
      text: 'Recommended',
      value: 'recommend',
      renderHelper: [biggerOrTo(0, '-'), tryTransNumber],
      numFmt: '#,##',
    },

    non_recommend: {
      text: 'Not Recommended',
      value: 'non_recommend',
      renderHelper: [biggerOrTo(0, '-'), tryTransNumber],
      numFmt: '#,##',
    },

    tagged_star: {
      text: 'Starred Tag',
      value: 'tagged_star_count',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '-'), tryTransNumber],
    },

    free: {
      text: 'Free Played',
      value: 'free_played',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '-'), tryTransNumber],
    },
    refund: {
      text: 'Refund Game',
      value: 'refund_game',
      numFmt: '#,##',
      renderHelper: [biggerOrTo(0, '-'), tryTransNumber],
    },

    record_time: {
      text: 'On Record Time',
      value: 'record_time',
      // renderHelper: [formatTimeInfo],
    },

    review_time: {
      text: 'At Review Time',
      value: 'review_time',
      // renderHelper: [formatTimeInfo],
    },
  };
  const sortKeys = [
    'time',
    'sentiment',
    'language',
    'mentions',
    'recommend',
    'non_recommend',
    'tagged_star_count',
    'free_played',
    'refund_game',
    'record_time',
    'review_time',
  ];

  return [
    ...group_bys.map((item: string | number) => groupBysColumns[item]),
    ...metrics.map((key: string) => {
      const { text, value, ...otherConfig } = metricsColumns?.[key] || null;
      return {
        header: text,
        render: value,
        ...otherConfig,
      };
    }),
  ]
    .filter((item) => item !== null)
    .sort((a, b) => sortKeys.indexOf(a.render) - sortKeys.indexOf(b.render));
}
